if (!customElements.get('mini-cart')) {  
  class MiniCart extends HTMLElement {
    constructor() {
      super();
      this.cartModalOpen = false;
    }

    connectedCallback() {
      this.cartUrl = this.dataset.cartUrl;
      this.sectionId = this.dataset.sectionId;
      this.cart = JSON.parse(this.dataset.cartJson) || null;
      this.classList.remove('loading');
      
      document.addEventListener('DOMContentLoaded', () => {
        this.init();
      });
      if (document.readyState === 'complete') this.init();

      this.setupStickyShadow();
    }
    
    init() {
      this.addDelegatedClickListeners();
    }
    
    addDelegatedClickListeners() { 
      document.addEventListener('click', (e) => {
        if (!this.isConnected) return;
        if (window.location.pathname === this.cartUrl) return;
        if(e.target.closest(`[href="${this.cartUrl}"]`)) {
            e.preventDefault();
            this.open();
            return;
        }
        if (e.target.closest('[data-close-cart]') && this.cartModalOpen) {
            this.close();
            document.querySelector('[data-cart-button]').focus();
            return;
        }
        if (!e.target.closest('mini-cart') && this.cartModalOpen) {
            this.close();
            return;
        }
      });

      window.addEventListener('submit', (e) => {
        const productForm = e.target.closest('[action="/cart/add"]');
        if(!productForm) return;

        e.preventDefault();

        let selling_plan = null;

        let discount = null;
        if (productForm.querySelector('[name="properties[Discount]"]') && productForm.querySelector('[name="properties[Discount]"]').value !== undefined) discount = productForm.querySelector('[name="properties[Discount]"]').value;

        const idToAdd = productForm.querySelector('[name="id"]').value;
        const propertyInputs = productForm.querySelectorAll('[data-form-property]');
        const properties = {};

        if (propertyInputs) {
          for (let input of propertyInputs) {
            const key = input.getAttribute('name').match(/\[(.*?)\]/)[1];
            const val = input.value;

            properties[key] = val;
          }
        }

        this.classList.add('loading');
        this.addToCart(idToAdd, selling_plan, discount, properties)
          .then(() => {
            this.open();
          })
          .finally(() => this.classList.remove('loading'));
      });

      this.addEventListener('click', (e) => {
        const clickedElement = e.target.closest('[data-cart-action]');
        if (!clickedElement) return;

        const {
          cartAction: action,
          lineItemId,
          lineItemKey,
          quantity,
        } = clickedElement.dataset;
        
        switch (action) {
          case 'updateQty':
            const scrollTop = this.querySelector('form').scrollTop;

            this.classList.add('loading');
            this.updateQty(lineItemKey, Number(quantity))
              .then((res) => {
                if (!res) return;
                this.updateCartHtml(res).then(() => {
                  this.querySelector('form').scrollTo({ top: scrollTop, left: 0, behavior: 'auto' });
                });
              }).finally(() => this.classList.remove('loading'));
          break;
          case 'options':
            const form = clickedElement.closest('form');
            form.classList.add('open');
            clickedElement.setAttribute('disabled', 'disabled');
            setTimeout(() => {
              const nextSelect = form.querySelector('select:not(.sp-sr-only)');
              if (nextSelect) nextSelect.focus();
            }, 0);
          break;
          default: break;
        }
      })

      document.addEventListener('multi_pack_add', async (e) => {
        const items = e.detail;

        this.classList.add('loading');

        try {
          const response = await fetch('/cart/add.js', {
            body: JSON.stringify({ items, sections: [this.sectionId] }),
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'xmlhttprequest'
            },
            method: 'POST'
          });

          const json = await response.json();

          if (!response.ok) {
            console.error(`multi pack add failed: ${response.status} ${response.statusText}`, json?.message || json);
            let message = json?.message || json;
            alert(message);
          }

          this.updateCartHtml(json);
        } finally {
          this.open();
          this.classList.remove('loading');
          document.dispatchEvent(new CustomEvent('multi_pack_added'));
          document.dispatchEvent(new Event('cart:updated'));
        }
      });
    }

    setupStickyShadow() {
      if (this.stickyIO) {
        this.stickyIO.disconnect();
        this.stickyIO = null;
      }

      const bar = this.querySelector('[data-totals]');
      const sentinel = this.querySelector('[data-sticky-sentinel]');
      if (!bar || !sentinel) return;

      const setStuck = (isStuck) => bar.classList.toggle('is-stuck', isStuck);

      this.stickyIO = new IntersectionObserver(
        ([entry]) => setStuck(!entry.isIntersecting),
        { threshold: 0 }
      );

      this.stickyIO.observe(sentinel);

      requestAnimationFrame(() => {
        const rect = sentinel.getBoundingClientRect();
        const inView = rect.bottom > 0 && rect.top < window.innerHeight;
        setStuck(!inView);
      });
    }

    open() {
      this.cartModalOpen = true;
      this.classList.remove('sp-translate-x-full', 'sp-invisible');
      if (!window.location.href.includes('/cart')) { 
        document.body.classList.add('sparky-overlay')
        document.body.classList.remove('!sp-overflow-auto')
      }
      this.trapFocus()  
    }

    close() {
      this.cartModalOpen = false;
      this.classList.add('sp-translate-x-full', 'sp-invisible');
      document.body.classList.remove('sparky-overlay');
      document.body.classList.add('!sp-overflow-auto')
      this.removeTrapFocus() 
    }

    trapFocus(element = this.querySelector('[data-inner-wrapper]')) {
      if (!element) return;
      const focusableElements = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
      this.firstFocusableEl = focusableElements[0];  
      this.lastFocusableEl = focusableElements[focusableElements.length - 1];
      setTimeout(() => {
        this.firstFocusableEl?.focus();  
      }, 200);
      
      this.addEventListener('keydown', (e) => this.focusListener(e));
    }
    
    removeTrapFocus() {
      this.firstFocusableEl = false;  
      this.lastFocusableEl = false;
      this.removeEventListener('keydown', this.focusListener);
    }

    focusListener(e) {
      if (e.key === 'Tab' || e.keyCode === 9) {
        if (e.shiftKey ) /* shift + tab */ {
          if (e.target === this.firstFocusableEl) {
            this.lastFocusableEl.focus();
            e.preventDefault();
          }
        } else /* tab */ {
          if (e.target === this.lastFocusableEl) {
            this.firstFocusableEl.focus();
            e.preventDefault();
          }
        }
      }
    }
    
    async getCart(open = true) {
      fetch(window.Shopify.routes.root + `?sections=${this.sectionId}`)
        .then((res) => {
          return res.json();
        })
        .then((json) => {
          this.updateCartHtml(json);
        })
        .finally(() => {
          if (open) this.open();
        })
      }

    async addToCart(id, selling_plan = null, discount = null, properties, quantity = 1) {
      const data = {
        id,
        quantity,
        sections: [this.sectionId]
      };

      if (properties && Object.keys(properties).length !== 0) {
        data.properties = properties;
        if (discount) data.properties['Discount'] = discount;
      }

      if (selling_plan) data.selling_plan = selling_plan;

      try {
        const response = await fetch('/cart/add.js', {
          body: JSON.stringify(data),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'xmlhttprequest'
          },
          method: 'POST'
        });

        const json = await response.json();

        if (!response.ok) {
          console.error(`add to cart failed: ${response.status} ${response.statusText}`, json?.message || json);
          let message = json?.message || json;
          alert(message);
        }

        this.updateCartHtml(json);
        document.dispatchEvent(new Event('cart:updated'));
        return json;
      } catch (err) {
        console.error('add to cart err', err);
        alert('Something went wrong adding this item to your cart. Please try again.');
        return null;
      }
    }

    async updateCartHtml(res) {
      let newHtml = res?.sections?.[`${this.sectionId}`] || res?.[`${this.sectionId}`];
      if (!newHtml) {
        this.getCart();
        return;
      }
      
      if (!newHtml) {
        alert('Unable to update cart. Refresh page to see your updates.');
        return;
      }

      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = newHtml;
      if (window.location.pathname.endsWith('/cart')) {
        this.classList.add('is-cart')
      }
      this.innerHTML = tempDiv.querySelector('mini-cart').innerHTML;
      const count = Number(tempDiv.querySelector('mini-cart').dataset.cartItemCount) || '';
      this.cart = JSON.parse(tempDiv.querySelector('mini-cart').dataset.cartJson) || null;
      [...document.querySelectorAll('[data-cart-count]')].forEach(cartCount => {
        cartCount.innerHTML = count > 0 ? count : '';
      });    
      
      this.setupStickyShadow();
    }
    
    async updateQty(id, quantity) {
      const data = {
        id,
        quantity,
        sections: [`${this.sectionId}`],
      };

      const cartContents = await fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .finally(() => document.dispatchEvent(new Event('cart:updated')))
        .catch((error) => {
          console.error('Error:', error);
        });

      const cart_count_bubbles = document.querySelectorAll('[data-cart-count]');

      cart_count_bubbles.forEach(bubble => {
        bubble.innerHTML = cartContents.item_count;
      });

      return cartContents;
    };
  }

  customElements.define('mini-cart', MiniCart);
}